import script from "./QuickPicks.vue?vue&type=script&setup=true&lang=js"
export * from "./QuickPicks.vue?vue&type=script&setup=true&lang=js"

import "./QuickPicks.vue?vue&type=style&index=0&id=7b25dbe6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7b25dbe6"]])

export default __exports__